import {GameEvent, isPlayerAction} from '@glark-newco/game-library';
import {isTilePayload, TilePayload} from '../SignlinesPayloadTypes';

/**
 * Returns only the tile‑payload actions from a list of GameAction objects.
 * Every projection can import this function – you get the DRY benefit without a
 * new piece of store state.
 */
export const filterTileEvents = (events: GameEvent[]): TilePayload[] =>
    events
        .filter(isPlayerAction)
        .filter(ev => isTilePayload(ev.payload))
        .map(ev => ev.payload as TilePayload);
